import { chooseActualCabinetSizes } from './../../redux/appReducer'
import { CategoryType } from './../../api/appAPI'
import {
  GridColumnVisibilityModel,
  GridFilterModel,
  GridSortModel,
} from '@mui/x-data-grid'
import {
  CabPropsType,
  CabType,
  HardwareType,
  MarkupType,
  MaterialType,
  UserType,
} from '../../api/appAPI'
import Item, { ItemPropsType } from '../../classes/Item'
import Section, { DividerPropsType, SectionProps } from '../../classes/Section'
import { ConfigsType } from '../../config'
import {
  actions as appActions,
  addCabinet,
  copyCabinet,
  deleteCabinet,
  editCabinet,
  shareCabinet,
  verifyToken,
} from '../../redux/appReducer'
import {
  actions as cabinetActions,
  CabinetProps,
  CabinetType,
  CornerCabinetProps,
  DoorPropsType,
  DoorType,
  DoorVisualType,
  DrawerPropsType,
  DrawerSlideType,
  HandlePropsType,
  LegPropsType,
  setSubsectionHeight,
  ShelvesPropsType,
} from '../../redux/cabinetReducer'
import { actions as itemActions } from '../../redux/itemReducer'
import { StateType } from '../../redux/store'
import { EnqueueSnackbarType } from '../common/Helpers'
import { SectionLock } from './Three'

export interface IProps {
  myWidth: 0.5 | 0.75 | 1
  configs: ConfigsType
  searchParams: URLSearchParams

  user: undefined | UserType
  isDemo: boolean
  windowSize: { width: number; height: number }
  isSidebarOpen: boolean
  hardwaresList: HardwareType[]
  itemsPropsList: ItemPropsType[]
  markups: MarkupType[]
  openItemsName: string[]
  items: Item[]
  materials: MaterialType[]
  cabinetProps: CabinetProps
  section: Section | undefined
  doorType: DoorType
  isFrontPanelsVisible: boolean
  handleProps: HandlePropsType
  viewSectionHeight: boolean
  legProps: LegPropsType
  baseLegCut: number
  splittedTop: boolean
  doorVisualType: DoorVisualType
  cabinetType: CabinetType
  gcInfo: { hash: string; cabinet: string; domain: string }
  userCabinets: CabType[]
  allCabinets: CabType[]
  actualCabinetTitle: string
  userCabinetsGridVisibilityModel: GridColumnVisibilityModel | undefined
  userCabinetsGridSortModel: GridSortModel | undefined
  userCabinetsGridFilterModel: GridFilterModel | undefined
  availableUsersEmails: string[]
  isAddingDivider: boolean
  cabinetAddonD: number
  cabinetAddonP: number
  actualCabinetCategory: CategoryType | undefined
  categoriesList: CategoryType[]
  isChangingHeight: boolean
  microvellumName: string
  isFirstLoadIframe: boolean
  isCorner: boolean
  cornerCabinetProps: CornerCabinetProps
  drawerSlideType: DrawerSlideType

  setCabinet(
    width: number,
    height: number,
    depth: number,
    legHeight: number,
    cabinetType: CabinetType,
    splittedTop: boolean,
    legProps: LegPropsType,
    baseLegCut: number,
    dividerProps: DividerPropsType[],
    doorsProps: DoorPropsType[],
    drawersProps: DrawerPropsType[],
    shelvesProps: ShelvesPropsType[],
    thickness: number
  ): void
  setCornerCabinet(
    type: CornerCabinetProps['type'],
    height: number,
    width1: number,
    width2: number,
    depth1: number,
    depth2: number,
    backWidth1: number,
    backWidth2: number,
    legHeight: number,
    cabinetType: CabinetType,
    splittedTop: boolean,
    legProps: LegPropsType,
    baseLegCut: number,
    dividerProps: DividerPropsType[],
    doorsProps: DoorPropsType[],
    drawersProps: DrawerPropsType[],
    shelvesProps: ShelvesPropsType[],
    thickness: number
  ): void
  setWindowSize(width: number, height: number): void
  setSidebarHeight(value: number): void
  setIsSidebarOpen(value: boolean): void
  setItems(arr: Item[]): void
  setItemsPropsList(arr: ItemPropsType[]): void
  addItemsProps(
    arr: ItemPropsType[],
    forShelves?: boolean,
    shelfSectionNumber?: string
  ): void
  setSectionProps(prop: SectionProps): void
  setSection(section: Section): void
  setDivider(sectionName: string, divider: DividerPropsType): void
  setDividers(arr: DividerPropsType[]): void
  addDividers(arr: DividerPropsType[]): void
  deleteDivider(dividerName: string): void
  setSubsectionHeight(
    sectionName: string,
    height: number,
    prevHeight: number,
    locks: SectionLock[]
  ): void
  setSectionDoor(sectionNumber: number, door?: DoorPropsType): void
  setSectionDrawer(sectionNumber: number, door?: DrawerPropsType): void
  setSectionShelves(sectionNumber: number, shelves?: ShelvesPropsType): void
  setDoors(arr: DoorPropsType[], hint: string): void
  setDrawers(arr: DrawerPropsType[]): void
  setShelves(arr: ShelvesPropsType[]): void
  setHeight(value: number, thickness: number, fromUI: boolean): void
  setCHeight(value: number, thickness: number, fromUI: boolean): void
  setWidth(value: number, thickness: number): void
  setIsFrontPanelsVisible(value: boolean): void
  setViewSectionHeight(value: boolean): void
  setOpenItem(itemName: string): void
  setActiveTab(value: number): void
  openHardwareDetails(id: number): void
  openMaterialDetails(id: number): void
  setGCInfo(h: string, c: string, d: string): void
  setIsInIframe(v: boolean): void
  setIsFirstLoadIframe(v: boolean): void
  verifyToken(token: string, e: EnqueueSnackbarType): void
  addCabinet(cabProps: CabPropsType, enqueueSnackbar: EnqueueSnackbarType): void
  editCabinet(
    id: number,
    cabProps: CabPropsType,
    enqueueSnackbar: EnqueueSnackbarType
  ): void
  copyCabinet(id: number, enqueueSnackbar: EnqueueSnackbarType): void
  deleteCabinet(id: number, enqueueSnackbar: EnqueueSnackbarType): void
  setActualCabinetTitle(value: string): void
  setUserCabinetsGridVisibilityModel(
    model: GridColumnVisibilityModel | undefined
  ): void
  setUserCabinetsGridSortModel(model: GridSortModel | undefined): void
  setUserCabinetsGridFilterModel(model: GridFilterModel | undefined): void
  shareCabinet(
    cabinetId: number,
    isReference: boolean,
    emails: string[],
    enqueueSnackbar: EnqueueSnackbarType
  ): void
  setIsAddingDivider(v: boolean): void
  setCabinetAddons(d: number, p: number): void
  setActualCabinetCategory(value: CategoryType | undefined): void
  chooseActualCabinetSizes(setDefaults?: boolean): void
  setIsChangingHeight(v: boolean): void
  setMicrovellumName(v: string): void
  setDrawerSlideType(v: DrawerSlideType): void
}

export const mapStateToProps = (state: StateType) => ({
  user: state.appReducer.user,
  isDemo: state.appReducer.isDemo,
  windowSize: state.appReducer.windowSize,
  isSidebarOpen: state.appReducer.isSidebarOpen,
  itemsPropsList: state.itemReducer.itemsPropsList,
  hardwaresList: state.itemReducer.hardwaresList,
  markups: state.itemReducer.markups,
  openItemsName: state.itemReducer.openItemsName,
  items: state.itemReducer.items,
  materials: state.itemReducer.materials,
  cabinetType: state.cabinetReducer.cabinetType,
  cabinetProps: state.cabinetReducer.props,
  section: state.cabinetReducer.section,
  doorType: state.cabinetReducer.doorType,
  isFrontPanelsVisible: state.cabinetReducer.isFrontPanelsVisible,
  handleProps: state.cabinetReducer.handleProps,
  viewSectionHeight: state.cabinetReducer.viewSectionHeight,
  legProps: state.cabinetReducer.legProps,
  baseLegCut: state.cabinetReducer.baseLegCut,
  splittedTop: state.cabinetReducer.splittedTop,
  doorVisualType: state.cabinetReducer.doorVisualType,
  gcInfo: state.appReducer.gcInfo,
  userCabinets: state.appReducer.userCabinetsList,
  allCabinets: state.appReducer.allCabinetsList,
  actualCabinetTitle: state.appReducer.actualCabinetTitle,
  userCabinetsGridVisibilityModel:
    state.appReducer.userCabinetsGrid.visibilityModel,
  userCabinetsGridSortModel: state.appReducer.userCabinetsGrid.sortModel,
  userCabinetsGridFilterModel: state.appReducer.userCabinetsGrid.filterModel,
  availableUsersEmails: state.appReducer.availableUsersEmails,
  isAddingDivider: state.cabinetReducer.isAddingDivider,
  cabinetAddonD: state.itemReducer.cabinetAddonD,
  cabinetAddonP: state.itemReducer.cabinetAddonP,
  actualCabinetCategory: state.appReducer.actualCabinetCategory,
  categoriesList: state.appReducer.categoriesList,
  microvellumName: state.appReducer.microvellumName,
  isChangingHeight: state.cabinetReducer.isChangingHeight,
  isCorner: state.cabinetReducer.isCorner,
  cornerCabinetProps: state.cabinetReducer.cornerProps,
  isFirstLoadIframe: state.appReducer.isFirstLoadIframe,
  drawerSlideType: state.cabinetReducer.drawerSlideType,
})

export const mapDispatchToProps = {
  setCabinet: cabinetActions.setCabinet,
  setCornerCabinet: cabinetActions.setCornerCabinet,
  setSidebarHeight: appActions.setSidebarHeight,
  setIsSidebarOpen: appActions.setIsSidebarOpen,
  setActiveTab: appActions.setActiveTab,
  setWindowSize: appActions.setWindowSize,
  openHardwareDetails: appActions.openHardwareDetails,
  openMaterialDetails: appActions.openMaterialDetails,
  setUserCabinetsGridVisibilityModel:
    appActions.setUserCabinetsGridVisibilityModel,
  setUserCabinetsGridSortModel: appActions.setUserCabinetsGridSortModel,
  setUserCabinetsGridFilterModel: appActions.setUserCabinetsGridFilterModel,
  setCabinetAddons: itemActions.setCabinetAddons,
  setItems: itemActions.setItems,
  setOpenItem: itemActions.setOpenItem,
  setItemsPropsList: itemActions.setItemsPropsList,
  addItemsProps: itemActions.addItemsProps,
  setSection: cabinetActions.setSection,
  setSectionProps: cabinetActions.setSectionProps,
  setDivider: cabinetActions.setDivider,
  addDividers: cabinetActions.addDividers,
  deleteDivider: cabinetActions.deleteDivider,
  setDividers: cabinetActions.setDividers,
  setSectionDoor: cabinetActions.setSectionDoor,
  setSectionDrawer: cabinetActions.setSectionDrawer,
  setSectionShelves: cabinetActions.setSectionShelves,
  setDoors: cabinetActions.setDoors,
  setDrawers: cabinetActions.setDrawers,
  setShelves: cabinetActions.setShelves,
  setHeight: cabinetActions.setHeight,
  setCHeight: cabinetActions.setCHeight,
  setWidth: cabinetActions.setWidth,
  setIsFrontPanelsVisible: cabinetActions.setIsFrontPanelsVisible,
  setViewSectionHeight: cabinetActions.setViewSectionHeight,
  setIsAddingDivider: cabinetActions.setIsAddingDivider,
  setGCInfo: appActions.setGCInfo,
  setIsInIframe: appActions.setIsInIframe,
  setIsFirstLoadIframe: appActions.setIsFirstLoadIframe,
  setActualCabinetTitle: appActions.setActualCabinetTitle,
  setActualCabinetCategory: appActions.setActualCabinetCategory,
  setMicrovellumName: appActions.setMicrovellumName,
  setIsChangingHeight: cabinetActions.setIsChangingHeight,
  setDrawerSlideType: cabinetActions.setDrawerSlideType,
  addCabinet,
  editCabinet,
  copyCabinet,
  deleteCabinet,
  shareCabinet,
  setSubsectionHeight,
  chooseActualCabinetSizes,
  verifyToken,
}
